export default {
  categoryAll: 'All',
  categoryCommands: 'Command',
  categoryAgents: 'Agents',
  categoryFiles: 'Files',
  categoryTasks: 'Tasks',
  categoryProjects: 'Projects',
  categoryChannels: 'Channels',
  categoryPeople: 'People',
  searchPlaceholder: 'Search...',
  searchActionsPlaceholder: 'Search actions...',
  openFavoritePlaceholder: 'Open favorite...',
  noResultsFound: 'No results found',
  backWithEsc: 'Back (Esc)',
  moreCount: '+{{count}} more',
  navigate: 'Navigate',
  hintRunAction: 'Run action',
  hintBack: 'Back',
  hintSearch: 'Search',
  hintSearchInNewSplit: 'Search in new split',
  hintAskAi: 'Ask AI',
  hintOpen: 'Open',
  hintCategory: 'Category',
  hintClose: 'Close',
  openInNewSplit: 'Open in new split',
  moveSelectionDown: 'Move selection down',
  moveSelectionUp: 'Move selection up',
  selectItem: 'Select item',
  closeCommandMenu: 'Close command menu',
  goBack: 'Go back',
  nextCategory: 'Next category',
  previousCategory: 'Previous category',
  hotkeyThen: 'then',
  searchFor: 'Search for “{{query}}”',
  askAiAbout: 'Ask AI about “{{query}}”',
  projectBadge: 'Project',
  newProject: 'New project',
  contentAlreadyOpen: 'Content already open',
  unableToOpenConversation: 'Unable to open conversation. Please try again.',
  mobileSearchPlaceholder: 'Search…',
  mobileSearchOrCreate: 'Search or create',
  closeSearch: 'Close search',
  searchFullTextFor: 'Search full text for “{{query}}”',
  searchResults: 'Search results',
  loading: 'Loading…',
  searching: 'Searching…',
  noResults: 'No results',
  searchFailed: 'Search failed. Please try again.',
  retry: 'Retry',
  unableToOpenResult: 'Unable to open result. Please try again.',
};
